import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import Combobox from './combobox';

class Comboboxes extends React.Component {
  state = {
    values: [],
    mounted: false,
  };

  componentDidMount() {
    const values = this.props.value ? [...this.props.value] : [{ select: null, text: '', uuid: uuidv4(), }];
    const newState = {
      values,
      mounted: true,
    };
    this.setState(newState);
  }

  updateParent = (newArr) => {
    this.props.updateValue({ target: { value: newArr, name: this.props.name } });
  }

  handleChange = (event) => {
    // Determine what our index is
    const { name, value } = event.target;
    const fieldName = this.props.name;
    const index = 1 * name.replace(`${fieldName}_`, '');
    const newState = {
      ...this.state,
      values: [
        ...this.state.values,
      ],
    };
    newState.values[index].select = value.select;
    newState.values[index].text = value.text;
    this.setState(newState);
    this.updateParent(newState.values);
  }

  addNewBox = (e) => {
    e.preventDefault();
    const newState = {
      ...this.state,
      values: [
        ...this.state.values,
        {
          select: null,
          text: '',
          uuid: uuidv4(),
        },
      ],
    };
    this.setState(newState);
    this.updateParent(newState.values);
  }
  remove = (i) => {
    const newState = {
      ...this.state,
      values: [...this.state.values],
    };
    console.log('splicing at ', i);
    newState.values.splice(i, 1);
    console.log(newState.values, 'the values...');
    this.setState(newState);
    this.updateParent(newState.values);
  }

  render() {
    const { field, name } = this.props;
    const { values, mounted } = this.state;
    if (!mounted) {
      return null;
    }
    // console.log(field, 'the field');
    if (!field || !field.options || !field.options.length) {
      return null;
    }

    // Return a list of checkboxes, with each one tracking it's checked/unchecked state


    return (
      <div className="relative pb-1">
        {
          values.map((value, i) => {
            const mockedField = {
              type: 'combobox',
              options: field.options,
              placeholder: field.placeholder,
            };
            return (
              <div className="flex" key={value.uuid}>
                <div className="w-5/6">
                  <Combobox
                    field={mockedField}
                    updateValue={this.handleChange}
                    name={`${name}_${i}`}
                    submitting={this.props.submitting}
                    value={value}
                  />
                </div>
                <div className="w-1/6 pl-3">
                  <button onClick={(e) => { e.preventDefault(); this.remove(i); }} className="bg-transparent hover:bg-red-500 text-red-700 font-semibold hover:text-white py-2 px-4 border border-red-500 hover:border-transparent rounded-full">
                    X
                  </button>
                </div>
              </div>
            );
          })
        }
        <a href="#" className="text-sm" onClick={this.addNewBox}>+ Add Another</a>
      </div>
    );
  }
};

export default Comboboxes;